import {
  cardTitle,
  grayColor,
  defaultFont,
} from "assets/jss/material-dashboard-pro-react.jsx";
import { primaryColor } from "assets/jss/material-dashboard-pro-react";

const gradedPersonProfileStyle = {
  // title: {
  //   color: grayColor[2],
  //   textDecoration: "none"
  // }
  title: {
    fontSize: "18px",
    fontWeight: "bolder",
    marginTop: "0",
    marginBottom: "0",
    color: "inherit"
  },
  circle: {
    borderRadius: "50%",
    maxWidth: "100px"
  },
  flexCenter: {
    justifyContent: "space-around",
    alignItems: "center",
  },
  justify: {
    justifyContent: "space-around",
  },
  alignItems: {
    alignItems: "center",
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  cardBody: {
    marginLeft: "30px",
  },
  gridItem: {
    marginLeft: "20px"
  },
  paddingInput: {
    paddingRight: "20px"
  },
  padding10px: {
    padding: "10px"
  },
  padding20px: {
    padding: "20px",
  },
  box1px: {
    borderStyle: "solid",
    borderWidth: "1px 1px 1px 1px",
    borderColor: grayColor[0],
    textAlign: "center",
  },
  box1pxUpper: {
    borderStyle: "solid",
    borderWidth: "1px 1px 1px 1px",
    borderColor: grayColor[0],
    textAlign: "center",
  },
  box1pxBottom: {
    borderStyle: "solid",
    borderWidth: "0px 1px 1px 1px",
    borderColor: grayColor[0],
    textAlign: "center",
  },
  gradeInput: {
    textAlign: "right",
  },
  flexBox: {
    flexGrow: 1,
  },
  outlinedButton: {
    borderStyle: "solid",
    borderWidth: "1px",
    borderRadius: "30px",
    marginBottom: "8px"
  },
  hasDocButton: {
    backgroundColor: primaryColor[0],
    color: "white"
  },
  formSectionTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontSize: '1.5em',
    fontWeight: 'bold'
  }
}

export default gradedPersonProfileStyle;